<template>
  <el-dialog
    title="选择地图位置"
    :visible.sync="dialogVisible"
    width="1000px"
    :before-close="handleClose"
    :close-on-click-modal="false"
    class="map-select-dialog"
    :append-to-body="true"
    top="5vh"
  >
    <div class="map-select-container">
      <div class="map-wrapper">
        <div class="searchInput">
          <input ref="searchInput" placeholder="请输入地址" />
        </div>
        <el-amap
          ref="viewMap"
          @init="initMap"
          :zoom="zoom"
          :center="center"
          :resizeEnable="true"
          :dragEnable="true"
          :zoomEnable="true"
          class="amap"
        >
        </el-amap>
      </div>
      <div class="locations">
        <div
          class="location-item"
          :class="{ active: selectedLocation === item }"
          v-for="(item, index) in poiList"
          :key="index"
          @click="handleLocationItemClick(item)"
        >
          <div class="location-item-name">
            <span v-if="index === 0">[当前位置]</span>{{ item.name }}
          </div>
          <div class="location-item-address">{{ item.address }}</div>
        </div>
      </div>
    </div>

    <div slot="footer" class="dialog-footer">
      <el-button @click="handleClose">取消</el-button>
      <el-button
        type="primary"
        @click="confirmSelection"
        :disabled="!selectedLocation"
      >
        确认选择
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: "MapSelect",
  props: {
    initialCenter: {
      type: Array,
      default: () => [113.666502, 34.752278],
    },
    initialZoom: {
      type: Number,
      default: 10,
    },
  },
  data() {
    return {
      dialogVisible: false,
      center: this.initialCenter,
      zoom: this.initialZoom,
      map: null,
      geocoder: null,
      isSelecting: false,
      selectedLocation: {
        lng: null,
        lat: null,
        address: "",
        name: "",
      },
      poiList: [],
    };
  },
  beforeDestroy() {
    this.map && this.map.destroy();
  },
  methods: {
    open(location) {
      if (location) {
        if (location.lng && location.lat) {
          location.position = [Number(location.lng), Number(location.lat)];
        }
        this.selectedLocation = location;
        if (this.map) {
          this.map.setCenter(location.position);
          this.map.setZoom(15);
        }
      } else {
        this.selectedLocation = {
          lng: null,
          lat: null,
          address: "",
          name: "",
        };
        if (this.map) {
          this.map.setCenter([113.666502, 34.752278]);
          this.map.setZoom(10);
        }
      }
      this.dialogVisible = true;
    },

    close() {
      this.dialogVisible = false;
      this.selectedLocation = {
        lng: null,
        lat: null,
        address: "",
        name: "",
      };
      // this.map && this.map.destroy();
    },

    handleClose() {
      this.$confirm("确定要关闭吗？未保存的选择将会丢失", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.close();
        })
        .catch(() => {
          // 取消关闭
        });
    },
    initMap(map) {
      let _this = this;
      this.map = map;
      if (this.selectedLocation.position) {
        this.map.setCenter(this.selectedLocation.position);
        this.map.setZoom(15);
      }
      let positionPicker = new window.AMapUI.PositionPicker({
        mode: "dragMap",
        map: this.map,
        defaultPosition: [116.397428, 39.90923],
        defaultZoom: 15,
        defaultRotation: 0,
        defaultPitch: 0,
      });
      positionPicker.on("success", function (positionResult) {
        _this.poiList = [
          ...positionResult.regeocode.pois.map((item) => {
            return {
              ...positionResult.regeocode.addressComponent,
              position: item.location,
              ...item,
            };
          }),
        ];
        _this.selectedLocation = _this.poiList[0];
      });
      positionPicker.on("fail", function (positionResult) {
        console.log(positionResult);
      });

      positionPicker.start();
      let poiPicker = new window.AMapUI.PoiPicker({
        input: _this.$refs.searchInput,
      });
      poiPicker.on("poiPicked", function (poiResult) {
        map.setCenter(poiResult.item.location);
      });
    },
    confirmSelection() {
      this.$emit("confirm", this.selectedLocation);
      this.close();
    },
    handleLocationItemClick(item) {
      this.selectedLocation = item;
      this.map.setCenter(item.position);
    },
    setLocation(location) {
      this.selectedLocation = location;
      this.map.setCenter(location.position);
    },
  },
};
</script>

<style lang="scss" scoped>
.map-select-dialog {
  /deep/.el-dialog__body {
    padding: 0;
    height: 600px;
    padding: 10px 20px 30px 20px;
  }

  /deep/.el-dialog__footer {
    padding-bottom: 5px;
  }
}

.map-select-container {
  width: 100%;
  height: 600px;
  display: flex;
  gap: 20px;
  .locations {
    width: 500px;
    height: 100%;
    background: white;
    border-radius: 8px;
    padding: 12px;
    border: 1px solid #ebeef5;
    overflow-y: auto;
    overflow-x: hidden;

    .location-item {
      padding: 10px;
      border-radius: 6px;
      border: 1px solid #ebeef5;
      margin-bottom: 10px;
      cursor: pointer;
      &.active {
        border: 1px solid #409eff;
      }
      &:hover {
        background: #f5f7fa;
        border: 1px solid #409eff;
      }
      .location-item-name {
        font-size: 14px;
        font-weight: 600;
        color: #303133;
        margin-bottom: 5px;
      }
      .location-item-address {
        font-size: 12px;
        color: #909399;
      }
    }
  }
}

.map-wrapper {
  width: 100%;
  height: 100%;
  position: relative;

  .searchInput {
    position: absolute;
    top: 20px;
    left: 20px;
    z-index: 1000;
    width: 400px;
    padding: 10px;
    width: 400px;
    border: 1px solid #ebeef5;
    border-radius: 6px;
    background: white;
    input {
      width: 100%;
      height: 100%;
      border: none;
      outline: none;
      background: transparent;
    }
  }

  .amap {
    width: 100%;
    height: 100%;
  }

  .control-group {
    display: flex;
    flex-direction: column;
    gap: 8px;
    background: white;
    border-radius: 8px;
    padding: 12px;
    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);
    position: absolute;
    top: 20px;
    right: 20px;
    z-index: 1000;
    display: flex;
    flex-direction: column;
    gap: 15px;

    .el-button {
      width: 40px;
      height: 40px;
      padding: 0;
      border-radius: 6px;

      &:hover {
        transform: scale(1.05);
      }
    }
  }

  .location-info {
    background: white;
    border-radius: 8px;
    padding: 16px;
    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);
    width: 280px;
    position: absolute;
    top: 100px;
    right: 20px;
    z-index: 1000;

    .info-header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 12px;
      padding-bottom: 8px;
      border-bottom: 1px solid #ebeef5;

      .title {
        font-size: 14px;
        font-weight: 600;
        color: #303133;
      }
    }

    .info-content {
      .coordinate,
      .address,
      .name {
        display: flex;
        align-items: center;
        margin-bottom: 8px;

        .label {
          font-size: 12px;
          color: #909399;
          min-width: 50px;
          margin-right: 8px;
        }

        .value {
          font-size: 12px;
          color: #303133;
          word-break: break-all;
        }
      }

      .name {
        .el-input {
          flex: 1;
        }
      }
    }
  }
}

.dialog-footer {
  text-align: right;
  padding: 20px;
  border-top: 1px solid #ebeef5;
}

:deep(.amap-logo) {
  display: none !important;
}

:deep(.amap-copyright) {
  display: none !important;
}

:deep(.amap-search-box) {
  .amap-search-box-input {
    border-radius: 6px;
    border: 1px solid #dcdfe6;

    &:focus {
      border-color: #409eff;
    }
  }
}
</style>
